/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Spending_Cap_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Set a monthly spending cap to protect against runaway usage from buggy scripts or compromised API keys." |
*
* @param {Gateway_Spending_Cap_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_spending_cap_empty_description = /** @type {((inputs?: Gateway_Spending_Cap_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Spending_Cap_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Setze ein monatliches Ausgabenlimit, um dich vor unerwarteten Kosten durch fehlerhafte Skripte oder kompromittierte API-Keys zu schützen.")
	return /** @type {LocalizedString} */ ("Set a monthly spending cap to protect against runaway usage from buggy scripts or compromised API keys.")
});